import AgeSuitabilitiesApi from '../api/AgeSuitabilitiesApi';
import AgeSuitabilitiesConstants from '../constants/AgeSuitabilitiesConstants';
import composeGlobalSuccessMessaging from '../helpers/messaging/composeGlobalSuccessMessaging';
import composeUgcSuccessMessaging from '../helpers/messaging/composeUgcSuccessMessaging';

function addAgeSuitability({ metadataId, min, postSuccess }) {
  return {
    metadataId,
    postSuccess,
    types: [
      AgeSuitabilitiesConstants.ADD_AGE_SUITABILITIES_REQUEST,
      AgeSuitabilitiesConstants.ADD_AGE_SUITABILITIES_SUCCESS,
      AgeSuitabilitiesConstants.ADD_AGE_SUITABILITIES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      AgeSuitabilitiesApi.addAgeSuitability(
        {
          metadataId,
          min,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      ),
    apiSuccess: (response, store) => ({
      messaging: composeUgcSuccessMessaging({
        response,
        store,
        metadataId,
        type: 'ageRating'
      })
    })
  };
}

function updateAgeSuitability({ metadataId, ageSuitabilityId, min, postSuccess }) {
  return {
    metadataId,
    ageSuitabilityId,
    postSuccess,
    types: [
      AgeSuitabilitiesConstants.UPDATE_AGE_SUITABILITIES_REQUEST,
      AgeSuitabilitiesConstants.UPDATE_AGE_SUITABILITIES_SUCCESS,
      AgeSuitabilitiesConstants.UPDATE_AGE_SUITABILITIES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      AgeSuitabilitiesApi.updateAgeSuitability(
        {
          ageSuitabilityId,
          min,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      ),
    apiSuccess: () => ({
      messaging: composeUgcSuccessMessaging({
        type: 'ageRating',
        metadataId,
        updated: true
      })
    })
  };
}

function removeAgeSuitabilitySuccess(ageSuitabilityId) {
  return {
    messaging: composeGlobalSuccessMessaging('success_ugc_remove_message', { values: { ugcType: 'ageRating' } }),
    deletedEntities: [`ugc.ageSuitabilities.${ageSuitabilityId}`]
  };
}

function removeAgeSuitability({ metadataId, ageSuitabilityId, postSuccess }) {
  return {
    metadataId,
    ageSuitabilityId,
    postSuccess,
    types: [
      AgeSuitabilitiesConstants.REMOVE_AGE_SUITABILITIES_REQUEST,
      AgeSuitabilitiesConstants.REMOVE_AGE_SUITABILITIES_SUCCESS,
      AgeSuitabilitiesConstants.REMOVE_AGE_SUITABILITIES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      AgeSuitabilitiesApi.removeAgeSuitability(
        {
          ageSuitabilityId,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      ),
    apiSuccess: () => removeAgeSuitabilitySuccess(ageSuitabilityId)
  };
}

export default {
  addAgeSuitability,
  updateAgeSuitability,
  removeAgeSuitability
};
